import { render } from "./Notifications.vue?vue&type=template&id=7cc6e3c0&scoped=true&ts=true"
import script from "./Notifications.vue?vue&type=script&lang=ts"
export * from "./Notifications.vue?vue&type=script&lang=ts"

import "./Notifications.vue?vue&type=style&index=0&id=7cc6e3c0&lang=scss&scoped=true"

import exportComponent from "/Users/kameyamanaoki/dev/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cc6e3c0"]])

export default __exports__